export default {
    data() {
        return {
            BATCH_CONTACTS_LIST_STATUS_FRESH: 'FRESH',
            BATCH_CONTACTS_LIST_STATUS_PROCESSING: 'PROCESSING',
            BATCH_CONTACTS_LIST_STATUS_READY: 'READY',
            BATCH_CONTACTS_LIST_STATUS_FAILED: 'FAILED',
            BATCH_CONTACTS_LIST_STATUS_REFRESHING: 'REFRESHING',
        };
    },
};
